import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

// Shown when someone else's change to the open cargo clashes with the user's
// unsaved edits; the dialog stops taking in changes from then on (DORA-441).
const RemoteChangesConflictBanner = () => {
  const { t } = useTranslation(["shipmentModal"]);
  return (
    <div
      className="shipment-dialog__errors-section"
      data-testid="cargo-remote-conflict-banner"
    >
      <FontAwesomeIcon
        className="shipment-dialog-errors-section__icon"
        icon={faExclamationTriangle}
      />
      <div>
        <div className="shipment-dialog-errors-section__title">
          {t("shipmentModal:remoteChangesConflict.title")}
        </div>
        <div>{t("shipmentModal:remoteChangesConflict.text")}</div>
      </div>
    </div>
  );
};

export default RemoteChangesConflictBanner;
